import { default as kirkMp3 } from './kirk.mp3';
import { default as kirkMp4 } from './kirk.mp4';
import { default as kirkOgg } from './kirk.ogg';

export default {
  'kirk-mp3': kirkMp3,
  'kirk-mp4': kirkMp4,
  'kirk-ogg': kirkOgg,
};
